import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  size?: 'sm' | 'md' | 'lg';
  rounded?: boolean;
  icon?: string;
  className?: string;
}

export default function Badge({
  children,
  variant = 'primary',
  size = 'md',
  rounded = false,
  icon,
  className = '',
}: BadgeProps) {
  const variantStyles = {
    primary: 'bg-brand-100 text-brand-800',
    secondary: 'bg-ink-100 text-ink-700',
    success: 'bg-emerald-100 text-emerald-800',
    danger: 'bg-red-100 text-red-800',
    warning: 'bg-accent-100 text-accent-800',
    info: 'bg-sky-100 text-sky-800',
  };

  const sizeStyles = {
    sm: 'px-2 py-0.5 text-[11px]',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm',
  };

  const roundedClass = rounded ? 'rounded-full' : 'rounded';

  return (
    <span
      className={`
        inline-flex items-center font-bold tracking-wide uppercase
        ${variantStyles[variant]}
        ${sizeStyles[size]}
        ${roundedClass}
        ${className}
      `}
    >
      {icon && <i className={`fas ${icon} mr-1`}></i>}
      {children}
    </span>
  );
}
